export default __webpack_public_path__ + "phones.ada0d897ac3c902a4f5981f57f37fb35.png";